<template>
  <div>
    <template>
      <h4 class="not-margin" :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
        <i class="fal fa-users" :style="{ width: '25px', fontSize: '18px' }"></i>
        ເເກ້ໄຂ ຜູ້ໃຊ້ລະບົບ
      </h4>
    </template>

    <div class="field" :style="{marginTop: '15px'}">
      <div class="control">
        <label class="label">
          ລະຫັດຜູ້ໃຊ້
          <span class="text-danger">* {{ errors.first('userCardid') }}</span>
          <span class="text-danger">
                        {{ server_errors.userCardid }}
                    </span>
        </label>
        <input
            class="input"
            name="userCardid"
            type="text"
            placeholder="ກະລຸນາປ້ອນລະຫັດຜູ້ໃຊ້..."
            v-model="listBranchUser.userCardid"
            v-validate="'required|max:225'"
        >
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ຊື່ຜູ້ໃຊ້ລະບົບ
          <span class="text-danger">* {{ errors.first('username') }}</span>
          <span class="text-danger">
                        {{ server_errors.userName }}
                    </span>
        </label>
        <input class="input" name="username" type="text"
               placeholder="ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້ລະບົບກ່ອນ..." v-model="listBranchUser.userName"
               v-validate="'required|min:2|max:225'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ອີເມວ
          <span class="text-danger">* {{ errors.first('user_email') }}</span>
          <span class="text-danger">
                        {{ server_errors.userEmail }}
                    </span>
        </label>
        <input class="input" type="text" name="user_email" placeholder="ກະລຸນາປ້ອນອີເມວກ່ອນ..."
               v-model="listBranchUser.userEmail" v-validate="'required|email|min:5|max:255'">
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          ເບີໂທລະສັບ
          <span class="text-danger">* {{ errors.first('user_tel') }}</span>
          <span class="text-danger">
                        {{ server_errors.userTel }}
                    </span>
        </label>
        <input
            class="input"
            type="text" name="user_tel"
            placeholder="ກະລຸນາປ້ອນເບີກ່ອນ..."
            v-model="listBranchUser.userTel"
            v-validate="'required|min:7|max:15'"
        >
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">ເລືອກສາຂາ
          <span class="text-danger">*</span>
          <span class="text-danger">
                        {{ server_errors.branchId }}
                    </span>
        </label>
        <model-list-select
            :list="branches"
            v-model="listBranchUser.branchId"
            placeholder="ເລືອກສາຂາປາຍທາງ"
            option-text="name"
            option-value="id"
            selectedItem="name"
        >
        </model-list-select>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">ສະຖານະການໃຊ້:</label>
        <div class="select">
          <select class="input" v-model="listBranchUser.is_active">
            <option value="1">active</option>
            <option value="0">disable</option>
          </select>
        </div>
      </div>
    </div>
    <div class="field" v-if="displayCheckbox">
      <div class="control">
        <div class="center">
          <vs-checkbox v-model="option">
            ເພີ່ມສິດເປັນຜູ້ໃຊ້ສາງ
          </vs-checkbox>
        </div>
      </div>
    </div>

    <div class="field" :style="{marginTop: '25px'}">
      <label class="label" :style="{textAlign: 'left'}">
        ບົດບາດ ຜູ້ໃຊ້ລະບົບ
        <span class="text-danger">* {{ errors.first('role') }}</span>
        <span class="text-danger">
                    {{ server_errors.roleId }}
                </span>
      </label>
      <div :style="{marginTop: '15px'}">
        <vs-select filter multiple placeholder="ກະລຸນາເລືອກບົດບາດກ່ອນ..." v-if="roleUsers.length"
                   @change="ShowPermission()" name="role" v-model="listBranchUser.roleId">
          <vs-option :label="roleUser.name" :value="roleUser.id" v-for="(roleUser, i) in roleUsers" :key="i">
            {{ roleUser.name }}
          </vs-option>
        </vs-select>
      </div>
    </div>

    <div v-if="permissions.length">
      <hr>
      <template>
        <h4 class="not-margin"
            :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left', marginTop: '-15px' }">
          <i class="fal fa-users" :style="{ width: '25px', fontSize: '18px' }"></i>
          ໜ້າທີ່ຂອງບົດບາດ
        </h4>
      </template>
      <div class="box-list-permission">
        <div class="permission" v-for="(permission, idx) in permissions" :key="idx">
          {{ permission.permissionName }}
        </div>
      </div>
    </div>

    <div class="field" :style="{marginTop: '25px'}">
      <label class="label" :style="{textAlign: 'left'}">
        ຫົວໜ້າແຂວງ
      </label>
      <div :style="{marginTop: '15px'}">
        <vs-select filter multiple placeholder="ກະລຸນາເລືອກແຂວງກ່ອນ..." v-if="listProvinces.length"
                   name="province" v-model="listBranchUser.provinceId">
          <vs-option :label="province.name" :value=" province.id" v-for="(province, i) in listProvinces" :key="i">
            {{ province.name }}
          </vs-option>
        </vs-select>
      </div>
    </div>

    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat @click="ValidateForm()" class="form-btn-loading" :loading="btnLoading">ເເກ້ໄຂ
          ຜູ້ໃຊ້ລະບົບ
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import MinxinsEditUser from '../../../../../Mixins/Branch/User/Edit';
import {ValidateBranchUsers} from '../../../../../Plugins/Validation/Branch/Users/validete';
import {ModelListSelect} from 'vue-search-select';

export default {
  components: {
    ModelListSelect,
  },

  props: ['roleUsers', 'listBranchUser', 'listProvinces'],

  mixins: [MinxinsEditUser],

  created() {
    this.ShowPermission();
    this.FetchData();
    ValidateBranchUsers(this);
  }
}
</script>
<style lang="scss" scoped>
.label-title {
  text-align: left;
  margin-top: -15px;
}

.box-list-permission {
  text-align: left;
  margin-top: 10px;
  background: rgba(var(--vs-gray-2), 1);
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
  max-width: 368px;

  .permission {
    background: $primary-color;
    padding: 5px 5px 5px 5px;
    color: $white;
    border-radius: 5px;
    width: auto;
    margin: 3px;
    text-align: center;
    font-size: 14px;
  }
}
</style>
